import React from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'white' | 'green' | 'gray' | 'blue';
  className?: string;
}

/**
 * Reusable Spinner Component
 * 
 * Usage examples:
 * 
 * // Small white spinner for buttons
 * <Spinner size="sm" color="white" />
 * 
 * // Medium blue spinner for general loading
 * <Spinner size="md" color="blue" />
 * 
 * // Large gray spinner for page loading
 * <Spinner size="lg" color="gray" />
 * 
 * // Custom styling
 * <Spinner size="md" color="blue" className="ml-2" />
 */

const Spinner: React.FC<SpinnerProps> = ({ 
  size = 'md', 
  color = 'white', 
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  };

  const colorClasses = {
    white: 'border-white',
    green: 'border-green-600',
    gray: 'border-gray-600',
    blue: 'border-blue-600'
  };

  return (
    <div 
      className={`animate-spin rounded-full border-2 border-t-transparent ${sizeClasses[size]} ${colorClasses[color]} ${className}`}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default Spinner;
